import * as React from 'react'

export function OtherSecurity(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M21.799 12.421l-6.244 7.497a.863.863 0 01-1.243.09l-3.966-3.574a1.05 1.05 0 01-.085-1.472 1.021 1.021 0 011.178-.264l3.33 1.46 5.83-4.956a.844.844 0 011.139.04.871.871 0 01.06 1.18m3.286-5.125c-1.763-.149-6.695-.968-8.311-2.932a1.003 1.003 0 00-1.545 0C13.608 6.334 8.68 7.15 6.917 7.297A1.001 1.001 0 006 8.294v9.9c0 7.691 6.536 9.777 9.993 9.806C19.465 27.971 26 25.885 26 18.194v-9.9c0-.519-.398-.953-.916-.997'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
